import React from "react";

const BurgerButton = () => (
    <svg width={32} height={29}>
        <defs>
            <filter
                x="-12.5%"
                y="-10%"
                width="125%"
                height="128%"
                filterUnits="objectBoundingBox"
                id="prefix__a"
            >
                <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur
                    stdDeviation={1}
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                />
                <feColorMatrix
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                    in="shadowBlurOuter1"
                />
            </filter>
            <path
                d="M302 39a2 2 0 010 4h-14a2 2 0 010-4h14zm0-11a2 2 0 010 4h-14a2 2 0 010-4h14zm-22 0a2 2 0 010 4h-2a2 2 0 010-4h2zm22-10a2 2 0 010 4h-24a2 2 0 010-4h24z"
                id="prefix__b"
            />
        </defs>
        <g fill="#000" transform="translate(-274 -17)" fillRule="evenodd">
            <use filter="url(#prefix__a)" xlinkHref="#prefix__b"/>
            <use xlinkHref="#prefix__b"/>
        </g>
    </svg>
);

export default BurgerButton;
